module.exports = __webpack_public_path__ + "img/cns_printer_mac22.618a244f.png";